export enum CallDirection {
    Inbound,
    Outbound,
    Transfer,
    Other,
}

export namespace CallDirection {
    export function toString(callDirection: CallDirection): string {
        return CallDirection[callDirection].toString();
    }
}
